
//Author: Nik M
//https://github.com/nik-m2/react-column-resizer

module.exports = require('./dist/column-resizer.js');
